import ParticleField from '@/components/base/ParticleField';
import Header from '@/components/feature/Header';
import VerificationSection from './components/VerificationSection';

export default function Verification() {
  return (
    <div className="relative min-h-screen bg-black overflow-x-hidden">
      <ParticleField />
      <Header />
      
      <main className="relative z-10">
        <VerificationSection />
      </main>

      {/* Footer */}
      <footer className="relative z-10 py-12 border-t border-white/10">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <div className="w-8 h-8 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/e56119d9701c4940d688cc54fccf122e/60ae1d1cc04e0b663bfc83b27abd0288.png" 
                  alt="Fieldscale Logo" 
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="text-white font-bold text-xl tracking-wide">Fieldscale Technologies Ltd.</span>
            </div>
            
            <div className="flex items-center">
              <p className="text-white/60 text-sm">© {new Date().getFullYear()} Fieldscale Technologies Ltd. • UK Company No. 16734531 • All rights reserved</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
